import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonicalUrl,
  ogImage,
  ogType = 'website'
}) => {
  const defaultTitle = 'Savanna Skies Ltd - African Aircraft Leasing & Financing';
  const defaultDescription = 'African-owned aircraft leasing and financing company serving airlines across Africa. Flexible leasing solutions for Boeing, Airbus, Embraer, and De Havilland aircraft.';
  const defaultKeywords = 'aircraft leasing, aircraft financing, African aviation, Boeing leasing, Airbus leasing, aviation finance Africa';
  const defaultImage = 'https://customer-assets.emergentagent.com/job_0ccb6f97-1bfb-4ee2-9332-dc85509860bf/artifacts/liu25jwb_Savanna%20Skies%20Logo.jpeg';
  const siteUrl = 'https://www.savannaskies.co.za';

  const pageTitle = title ? `${title} | Savanna Skies Ltd` : defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords || defaultKeywords;
  const pageUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;
  const pageImage = ogImage || defaultImage;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
    </Helmet>
  );
};

export default SEO;
